var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { injectable } from 'inversify';
import { ValidationService } from '../validation';
import { HttpService } from '../http';
import { GetEventDto } from './dto';
let ActivityLogService = class ActivityLogService {
    constructor(validator, http) {
        this.validator = validator;
        this.http = http;
    }
    /**
     * Логировать на стороне сервиса такую пользовательскую активность, как "просмотреть заявку"
     *
     * @param getEventDto - Данные события
     */
    eventView(getEventDto) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.validator.validateOrReject(getEventDto, GetEventDto);
            yield this.http.post('/user/activity_log/event_view', { event_id: getEventDto.id }, { withSide: true });
        });
    }
    /**
     * Логировать на стороне сервиса такую пользовательскую активность, как "просмотреть профиль"
     */
    profileView() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.http.post('/user/activity_log/profile_view', {}, { withSide: true });
        });
    }
    /**
     * Логировать на стороне сервиса такую пользовательскую активность, как "сменить роль"
     *
     * @param userRole - Роль пользователя
     */
    changeSide(userRole) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.http.post('/user/activity_log/change_side', { to_side: userRole }, { withSide: true });
        });
    }
};
ActivityLogService = __decorate([
    injectable(),
    __metadata("design:paramtypes", [ValidationService,
        HttpService])
], ActivityLogService);
export { ActivityLogService };
